module.exports = __webpack_public_path__ + "img/glam2-01.344458f8.png";